<template>
  <template v-if="value">
    {{ money.format(parseFloat(value)) }}
  </template>
  <template v-else>
    -
  </template>
</template>

<script>
import { markRaw } from 'vue'
import money from '@/helpers/money.js'

export default {
  name: 'DatatablesFieldsMoneyField',

  props: ['value'],

  setup() {
    return {
      money: markRaw(money),
    }
  },
}
</script>
